import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { Observable, throwError } from "rxjs";
import { catchError, map, tap } from "rxjs/operators";
import { DialogComponent } from "src/app/ui/dialog/dialog.component";
import { SnackBarComponent } from "src/app/ui/snack-bar/snack-bar.component";
import { LoginService } from "../services/login.service";

@Injectable()
export class ResquestInterceptor implements HttpInterceptor {
    token: string;
    private spCharactersB64List: any = [btoa("%"), btoa("'"), btoa("#")];
    private arrKeysToTradeDbQuote: string[] = ["contractNumber"];

    constructor(
        private loginService: LoginService,
        private snackBar: MatSnackBar,
        private dialog: MatDialog,
        private router: Router
    ) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.loginService.isLoggedIn()) {
            req = this.addAuthenticationToken(req);
        }

        return next.handle(req).pipe(
            map(event => this.interceptorResponse(event)),
            catchError((error: HttpErrorResponse) => {
                switch (error.status) {
                    case 0:
                        this.errorHandler("Não foi possível processar a solicitação para o servidor");
                        return throwError(error);

                    case 400:
                        if (req.url.toString().includes("api/brokerByName")) return throwError(error);

						if (
							!(
								req.url.toString().includes("GetToEmail") &&
								this.router.routerState.snapshot.url.toString().includes("usuario/consultar")
							) &&
							!req.url.toString().includes("api/Insured/GetByNmPessoaOrNrCnpjCpf") &&
							!(
								req.url.toString().includes("api/takertoname") &&
								(this.router.routerState.snapshot.url.toString().includes("propostas") ||
									this.router.routerState.snapshot.url.toString().includes("usuario") ||
									this.router.routerState.snapshot.url.toString().includes("parametros") ||
									this.router.routerState.snapshot.url.toString().includes("tomador") ||
									this.router.routerState.snapshot.url.toString().includes("estrutura-comercial"))
							)
						) {
							if (!!error.error?.Errors) {
								this.showModal("Atenção!", error.error.Errors, null, "ENTENDI");
							}
							if (error.error.errors != undefined){
								this.showModal("Atenção!", error.error.errors, null, "ENTENDI");
							}
						}
						return throwError(error);

                    case 401:
                        var value = error.error.value;

                        if (value == null) {
                            if (error.error.errors[0].message) {
                                this.showModal("Atenção!", error.error.errors[0].message, null, "ENTENDI");
                                // Logout do sistema
                                this.loginService.logout();
                                this.router.navigate(["/login"]);
                                return throwError(error);
                            } else {
                                this.showModal("Atenção!", error.error.errors, null, "ENTENDI");
                                // Logout do sistema
                                this.loginService.logout();
                                this.router.navigate(["/login"]);
                                return throwError(error);
                            }
                        } else if (value.expired == true) {
                            this.showModal(
                                "Atenção",
                                error.error.errors[0].message,
                                null,
                                "DEFINIR NOVA SENHA"
                            ).componentInstance.eventSecondButton.subscribe(() => {
                                localStorage.setItem("passwordExpired", error.error.value.expired);
                                localStorage.setItem("token", error.error.value.token);
                                this.router.navigate(["/meu-perfil/perfil"]);
                            });
                        }
                        return throwError(error);

                    case 403:
                        this.snackBar.openFromComponent(SnackBarComponent, {
                            data: "Usuário sem permissão"
                        });
                        this.redirect404();
                        return throwError(error);

                    case 404:
                        this.errorHandler("RECURSO NAO ENCONTRADO!");
                        return throwError(error);

                    case 500:
                        if (error.error instanceof Blob) {
                            this.showModal(
                                "Atenção!",
                                "Documento não encontrado! Entre em contato com Administrador do Sistema.",
                                null,
                                "ENTENDI"
                            );
                        } else if (req.url.toString().includes("api/access/GetProfileClaimLink")) {
                            localStorage.removeItem("token");
                            localStorage.removeItem("profileClaim");
                            localStorage.removeItem("notification");
                            this.router.navigate(["/login"]);
                        } else {
                            if (!!error.error?.Errors) {
                                this.showModal("Atenção!", error.error?.Errors, null, "ENTENDI");
                            } else {
                                this.showModal("Atenção!", error.error?.errors, null, "ENTENDI");
                            }
                        }
                        return throwError(error);

                    case 511:
                        return throwError(this.showResultFromNetworkAuthReqCode(error));
                }
            })
        );
    }

    private addAuthenticationToken(request: HttpRequest<any>): HttpRequest<any> {
        return request.clone({
            setHeaders: {
                Authorization: `Bearer ${this.loginService.token}`,
                Token2FA: this.loginService.token2FA
            },
            withCredentials: true
        });
    }

    private errorHandler(error: string): void {
        this.snackBar.openFromComponent(SnackBarComponent, {
            data: error
        });
    }

    showModal(
        title: string,
        text: string,
        firstNameButton: string,
        secondNameButton: string
    ): MatDialogRef<DialogComponent, any> {
        const dialogRef = this.dialog.open(DialogComponent, {
            data: { title, text },
            height: "238px",
            width: "480px",
            disableClose: true
        });
        dialogRef.componentInstance.secondNameButton = secondNameButton;
        return dialogRef;
    }

    private interceptorResponse(event: HttpEvent<any>): HttpResponse<any> {
        if (event instanceof HttpResponse) {
            for (var key in event.body?.data) {
                if (typeof event.body.data[key] === "string" && !!event.body.data[key]) {
                    this.spCharactersB64List.forEach(spCharacter => {
                        if (event.body.data[key]?.indexOf(spCharacter) !== -1) {
                            event.body.data[key] = event.body.data[key].replace(new RegExp(spCharacter, "g"), atob(spCharacter));
                        }
                    });

                    if (this.isarrKeysToTradeDbQuote(key) && !!event.body.data[key]) {
                        event.body.data[key] = this.replaceDbQuoteBracketAtob(event.body.data[key]);
                    }
                }
            }
            return event;
        }
    }

    private isarrKeysToTradeDbQuote(key: string): boolean {
        return this.arrKeysToTradeDbQuote.some(x => x?.toUpperCase() === key?.toUpperCase());
    }

    private replaceDbQuoteBracketAtob(data: string) {
        const spCharacterList: any[] = [
            btoa(unescape(encodeURIComponent("“"))),
            btoa(unescape(encodeURIComponent("”"))),
            btoa(unescape(encodeURIComponent("("))),
            btoa(unescape(encodeURIComponent(")"))),
            btoa(unescape(encodeURIComponent('"')))
        ];
        spCharacterList.forEach(spCharacter => {
            data = data.replace(new RegExp(spCharacter, "g"), decodeURIComponent(escape(atob(spCharacter))));
        });

        return data;
    }

    private showResultFromNetworkAuthReqCode(error: HttpErrorResponse): HttpErrorResponse {
        localStorage.removeItem("token");
        localStorage.removeItem("vinculoCorretora");
        localStorage.removeItem("notification");
        localStorage.removeItem("home");
        localStorage.removeItem("profileClaim");
        localStorage.removeItem("propostas");
        this.loginService.handleLogin();
        return error;
    }

    private redirect404(): void {
        this.router.navigate(["not-found/404"]);
        return;
    }
}